import styled from 'styled-components';
import { PrimaryButton } from '@/components/button/button-component';
import { Row } from '@/components/grid/grid-component';

const HeaderButtonStyled = styled(PrimaryButton)`
  padding: 10px;
  margin: 4px;
`;

const StyledMainRow = styled(Row)`
  display: flex;
  justify-content: space-between !important;
  margin-top: 20px !important;
  margin-bottom: 20px !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
  padding: 24px !important;
  border-radius: 6px;
  width: 100%;
  background-color: ${({ theme }) => theme.COLOR_BLACK} !important;
`;

const StepDivider = styled.div`
  border-left: 2px solid ${({ theme }) => theme.COLOR_WHITE};
  width: 1px;
  height: 44px;
  transform: rotate(0deg);
`;

const StyledDiv = styled.div`
  display: flex;
  align-items: center;
`;

const StyledRevertButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 4px;
`;

const StyledTableHeader = styled.div`
  background: ${({ $background }) => $background || 'transparent'};
  display: flex;
  justify-content: space-between;
  height: 70px;
  align-items: center;
  padding: 0px 30px;
`;

const styledOptionsAll = {
  HeaderButtonStyled,
  StyledMainRow,
  StyledDiv,
  StepDivider,
  StyledRevertButtonContainer,
  StyledTableHeader,
};

export default styledOptionsAll;
